import { getCurrentInstance, useId, type AppContext } from 'vue'

const registryKey = Symbol.for('xjlv2.ui.controlIds')
interface Registry { next: number; applications: WeakMap<AppContext, number> }

/** Vue IDs are app-local; shell and independently mounted MFEs share a document. */
export function useControlId(): string {
  const local = useId()
  if (typeof document === 'undefined') return local
  const host = document as Document & { [registryKey]?: Registry }
  const registry = host[registryKey] ?? (host[registryKey] = { next: 0, applications: new WeakMap() })
  const application = getCurrentInstance()!.appContext
  let scope = registry.applications.get(application)
  if (scope === undefined) {
    scope = registry.next++
    registry.applications.set(application, scope)
  }
  return `${scope}-${local}`
}
